import { SplashScene, type SplashSceneProps } from './splash/SplashScene';

/** Launch splash (port of SplashScreenView.swift). Thin wrapper kept for existing imports. */
export function SplashView(props: SplashSceneProps) {
  return <SplashScene {...props} />;
}
